import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import Badge from 'react-bootstrap/Badge';
import { useTextTokens } from '../../providers/text-token-provider.esm.js';

const TagCategory = ({ variant, children, className, ...rest })=>{
    const textTokens = useTextTokens();
    let translatedText;
    if (typeof children === 'string' && textTokens?.tagCategories?.[children]) {
        translatedText = textTokens.tagCategories[children];
    }
    return jsx(Badge, {
        pill: true,
        bg: "none",
        className: classNames(className, 'border px-150 py-50 rounded-500 tag-category', {
            [`tag-category-${variant}`]: variant
        }),
        ...rest,
        children: translatedText || children
    });
};

export { TagCategory };
